export const authenticatedUserApi = {
  AUTHENTICATE_USER: "/auth/authenticate",
  CONFIGURATION: (organisationId: string): string =>
    `/auth/configuration/${organisationId}`,
  GET_USER: "/authenticatedUser",
  GET_SESSIONS: "/authenticatedUser/sessions",
  DELETE_SESSION: (id: string): string => `/authenticatedUser/sessions/${id}`,
  UPDATE_PASSWORD: "/authenticatedUser/password",
  UPDATE_PROFILE: "/authenticatedUser/profile",
  REFRESH_TOKEN: "/auth/refresh",
  SEND_VERIFY_CODE: "/auth/sendVerifyCode",
  FORGOT_ORGANISATION: "/auth/forgotOrganisation",
  MARK: "/users/introduceAdvaView/complete",
};

export const registerApi = {
  RESEND_EMAIL: `/register/resendEmail`,
  INDIVIDUAL: `/register/individual`,
  ORGANISATION: `/register/organisation`,
  COMPLETED: `/register/complete`,
};

export const organisationApi = {
  GET_ORGANISATIONS: "/organisations",
};

export const webAuthnApi = {
  REGISTRATIONS: "/security/twoFactor/webauthn/registrations",
  REGISTRATION_REQUEST: "/security/twoFactor/webauthn/register",
  REGISTRATION_REGISTER_FINISH: "/security/twoFactor/webauthn/register/finish",
  AUTHENTICATE_REQUEST: "/security/twoFactor/webauthn/authenticate",
  AUTHENTICATE_FINISH: "/security/twoFactor/webauthn/authenticate/finish",
};

export const trustedDevicesApi = {
  GET_TRUSTED_DEVICES: "/security/twoFactor/trustedDevices",
  DELETE_TRUSTED_DEVICES: (id: string): string =>
    `/security/twoFactor/trustedDevices/${id}`,
};

export const exportAPI = {
  MOVE_STUDY: (
    localApplicationEntityId: string,
    studyId: string,
    destinationApplicationEntityId: string
  ): string =>
    `/export/source/${localApplicationEntityId}/studies/${studyId}/destination/${destinationApplicationEntityId}`,

  MOVE_SERIES: (
    localApplicationEntityId: string,
    studyId: string,
    destinationApplicationEntityId: string,
    seriesId: string
  ): string =>
    `/export/source/${localApplicationEntityId}/studies/${studyId}/series/${seriesId}/destination/${destinationApplicationEntityId}`,
  MOVE_INSTANCE: (
    localApplicationEntityId: string,
    studyId: string,
    destinationApplicationEntityId: string,
    seriesId: string,
    instanceId: string
  ): string =>
    `/export/source/${localApplicationEntityId}/studies/${studyId}/series/${seriesId}/instances/${instanceId}/destination/${destinationApplicationEntityId}`,
};

export const StudyApi = {
  GET_STUDIES: "/studies",
  GET_BREAK_GLASS: "/breakGlass/patients",
  GET_PATIENT_STUDIES: (patientId: string): string =>
    `/patients/${patientId}/studies`,
  GET_STUDY_DETAIL: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}`,
  DOWNLOAD_STUDY_AS_ZIP: (portalId: string, studyId: string): string =>
    `/portals/${portalId}/studies/${studyId}/download/zip`,
  GET_SERIES: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}/series`,
  GET_ALL_SERIES: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}/series?idOnly=true&size=1000000`,
  GENERATE_PDF_REPORT: (
    portalId: string,
    patientId: string,
    studyId: string,
    id: string
  ): string =>
    `/portals/${portalId}/patients/${patientId}/studies/${studyId}/diagnosticReport/content/${id}/pdf`,
  GET_SERIES_DETAIL: (
    patientId: string,
    studyId: string,
    seriesId: string
  ): string => `/patients/${patientId}/studies/${studyId}/series/${seriesId}`,
  DOWNLOAD_STUDIES: "/studies/download",
  DOWNLOAD_STUDY_IMAGES: (
    patientId: string,
    studyId: string,
    portalId: string
  ): string =>
    `/portals/${portalId}/patients/${patientId}/studies/${studyId}/download/jpeg`,
  DOWNLOAD_BULK_SERIES: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}/series/download`,
  DOWNLOAD_SERIES_AS_ZIP: (
    patientId: string,
    studyId: string,
    seriesId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/download/zip`,
  GET_INSTANCES: (
    patientId: string,
    studyId: string,
    seriesId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances`,
  GET_INSTANCE: (
    patientId: string,
    studyId: string,
    seriesId: string,
    instanceId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances/${instanceId}`,
  GET_INSTANCE_HEADERS: (
    patientId: string,
    studyId: string,
    seriesId: string,
    instanceId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances/${instanceId}/headers`,
  DOWNLOAD_BULK_INSTANCE: (
    patientId: string,
    studyId: string,
    seriesId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances/download`,
  DOWNLOAD_INSTANCE: (
    patientId: string,
    studyId: string,
    seriesId: string,
    instanceId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances/${instanceId}/download`,
  DOWNLOAD_INSTANCE_JPEG: (
    patientId: string,
    studyId: string,
    seriesId: string,
    instanceId: string,
    frame: number
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances/${instanceId}/jpeg?quality=100&frame=${frame}&download=true`,
  GET_MEDDREAM_TOKEN: `/integrations/meddream/tokens`,
  GET_EUNITY_TOKEN: `/integrations/eunity/tokens`,
  GET_ADVAPACS_VIEWER_TOKEN: `/integrations/viewer/token`,
  GET_WEASIS_TOKEN: `/integrations/weasis/tokens`,
  GET_ZED_TOKEN: `/integrations/zed/tokens`,

  GET_SERIES_INSTANCE_IDS: (
    patientId: string,
    studyId: string,
    seriesId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances?idOnly=true&size=1000000`,

  GET_SERIES_THUMBNAIL: (
    patientId: string,
    studyId: string,
    seriesId: string
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/jpeg?quality=50&fallback=true`,

  GET_INSTANCE_THUMBNAIL: (
    patientId: string,
    studyId: string,
    seriesId: string,
    instanceId: string,
    frame: number
  ): string =>
    `/patients/${patientId}/studies/${studyId}/series/${seriesId}/instances/${instanceId}/jpeg?quality=80&fallback=true&frame=${frame}`,
  GET_DOCUMENTS: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}/documents`,
  SHARE_STUDIES: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}/shares`,
  MOVE_STUDY: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}/move`,
  VERIFY_SHARE_STUDIES: "/studies/shares",
  DIAGNOSTIC_REPORT: (
    portalId: string,
    patientId: string,
    studyId: string
  ): string =>
    `/portals/${portalId}/patients/${patientId}/studies/${studyId}/diagnosticReport`,
  GET_DIAGNOSTIC_REPORT_CONTENT: (
    portalId: string,
    patientId: string,
    studyId: string,
    id: string
  ): string =>
    `/portals/${portalId}/patients/${patientId}/studies/${studyId}/diagnosticReport/content/${id}`,
};

export const documentApi = {
  LIST_LOINC_CODES: "/codeSystems/loincCode",
  LIST: "/documents",
  LIST_DOCUMENTS_BY_PATIENT: (id: string): string =>
    `/patients/${id}/documents`,
  LIST_DOCUMENTS_BY_STUDY: (patientId: string, studyId: string): string =>
    `/patients/${patientId}/studies/${studyId}/documents`,
  DETAIL: (patientId: string, documentId: string): string =>
    `/patients/${patientId}/documents/${documentId}`,
};
export const samlApi = {
  GET_SAML_CONFIGURATIONS: "/saml2/idp",
  GET_SAML_CONFIGURATION: (id: string): string => `/saml2/idp/${id}`,
  GET_SP_ID: "/saml2/sp/id",
};
export const auditLogApi = {
  GET_AUDIT_LOGS: "/auditRecords",
  GET_AUDIT_LOG_XML_DATA: (id: string): string => `/auditRecords/${id}/data`,
  LIST_EVENT_ID: "/auditRecords/eventIds",
  LIST_EVENT_TYPE_CODE: "/auditRecords/eventTypeCodes",
  LIST_PARTICIPANT_OBJECT_TYPE_CODE: "/auditRecords/participantObjectTypeCodes",
  LIST_PARTICIPANT_OBJECT_TYPE_CODE_ROLE:
    "/auditRecords/participantObjectTypeCodeRoles",
  LIST_USER_ID_TYPE_CODE: "/auditRecords/userIDTypeCodes",
  LIST_EVENT_ACTION: "/auditRecords/eventActions",
  LIST_EVENT_OUTCOME: "/auditRecords/eventOutcomes",
};

export const userApi = {
  GET_USERS: "/users",
  GET_USER_DETAIL: (id: string): string => `/users/${id}`,
  GET_USER_TWO_FACTOR: (id: string): string => `/users/${id}/twoFactor`,
  UPDATE_USER_PASSWORD: (userId: string): string =>
    `/users/${userId}/resetPassword`,
};

export const settingAPI = {
  GET_LANGUAGES: "/languages",
  GET_DEFAULT_LANGUAGE_SETTING: "/settings/language/default",
  MAKE_LANGUAGE_DEFAULT: (code: string): string => `/settings/language/${code}`,
};

export const roleApi = {
  PERMISSIONS: "/permissions",
  ROLES: "/roles",
  ROLE_DETAIL: (id: string): string => `/roles/${id}`,
  USERS: "/users",
};

export const notificationAPI = {
  GET_NOTIFICATION: "/notifications",
  GET_COUNT_NOTIFICATION: "/notifications/count",
  DISMISS_ALL_NOTIFICATION: "/notifications/read",
  READ_NOTIFICATION: (id: string): string => `/notifications/read/${id}`,
};

export const customerPACSApi = {
  GET_CUSTOMER_PACS: "/portals",
  GET_CUSTOMER_PACS_DETAIL: (id: string): string => `/portals/${id}`,
  REQUEST_ACCESS: (id: string): string => `/portals/${id}/access`,
  GET_DISCLAIMER: (id: string): string => `/portals/${id}/disclaimer`,
};

export const twoFactorSettingAPI = {
  TWO_FACTOR_SETTING: "/security/twoFactor/settings",
};

export const mfaSensitiveApi = {
  patientVerifyRequest: "/portals/{portalId}/sensitive/verify/patient/request",
  patientVerifyCode: "/portals/{portalId}/sensitive/verify/patient/code",
};

export const countryAPI = {
  GET_COUNTRIES: "/countries",
  GET_COUNTRIES_PREFIX: "/countries/prefixes",
};

export const eulaAPI = {
  GET_LATEST_EULA: "/endUserLicenseAgreements/latest",
  CHECK_ACCEPT_EULA: "/endUserLicenseAgreements/current",
  ACCEPT_EULA: "/endUserLicenseAgreements/current/accept",
};

export const locationAPI = {
  GET_LOCATION: "/public/locate",
};

export const brandApi = {
  BRANDS: "/public/brands",
};

export const orderApi = {
  ORDER_GENERATE_PDF_REPORT_PDF: (
    portalId: string,
    patientId: string,
    orderId: string,
    id: string
  ): string =>
    `/portals/${portalId}/patients/${patientId}/orders/${orderId}/diagnosticReport/content/${id}/pdf`,
  ORDER_GET_DIAGNOSTIC_REPORT_CONTENT: (
    portalId: string,
    patientId: string,
    orderId: string,
    id: string
  ): string =>
    `/portals/${portalId}/patients/${patientId}/orders/${orderId}/diagnosticReport/content/${id}`,
  DIAGNOSTIC_REPORT: (
    portalId: string,
    patientId: string,
    studyId: string
  ): string =>
    `/portals/${portalId}/patients/${patientId}/orders/${studyId}/diagnosticReport`,
};

export const criticalResultApi = {
  GET_OWN: "/criticalResults/referred",
  GET_TO_ME: "/criticalResults/copiedToMe",
  GET_CRITICAL_RESULT: (id: string): string => `/criticalResults/${id}`,
  GET_CRITICAL_RESULT_VIEW: (id: string): string =>
    `/criticalResults/${id}/view`,
  GET_CRITICAL_COUNT: "/criticalResults/count",
  GET_CRITICAL_RESULT_STUDIES: (id: string): string =>
    `/criticalResults/${id}/studies`,
  CRITICAL_RESULT_ACKNOWLEDGE: (id: string): string =>
    `/criticalResults/${id}/acknowledge`,
  CRITICAL_RESULT_VIEWED: (id: string): string => `/criticalResults/${id}/view`,
};
